import { IInboxStatus } from "../../apis/ledger";

export const INBOX_STATUSES: IInboxStatus[] = ["POSTED", "RECEIVED", "PENDING_COST", "FAILED", "SKIPPED"];

export const INBOX_EVENT_TYPES = [
  "delivery.completed",
  "returns.return-request.completed",
  "returns.damaged-inventory.recorded",
  "inventory.adjustment.adjusted",
  "inventory.inbound-receipt.recorded",
];

/** Тэмдэглэлийн анги: events.module.css-ийн pill*. */
export const STATUS_PILL: Record<IInboxStatus, string> = {
  POSTED: "pillPosted",
  RECEIVED: "pillReceived",
  PENDING_COST: "pillPending",
  FAILED: "pillFailed",
  SKIPPED: "pillSkipped",
};

/** last_error-ийн эхний мөр (жагсаалтад). */
export const firstLine = (value: string | null | undefined) =>
  (value ?? "").split("\n").find((l) => l.trim().length > 0)?.trim() ?? "";
